/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { JobSpecTemplateFilterDto, JobSpecTemplateListItemDto } from '@gh/builder-shared-data';

export type JobSpecTemplateFinderFilter = JobSpecTemplateFilterDto;
export type JobSpecTemplateFinderListItem = JobSpecTemplateListItemDto;

export const getJobSpecTemplateFinderListItemId = ({ id }: JobSpecTemplateFinderListItem) => id;
